import { formService, FormElement } from '@common';
import {
  EkNumbersValidator,
  HarvestDateValidator,
  ParcelAreaValidator,
  PlantingDateValidator,
  YieldAmountValidator
} from '../modules/parcel/validators';
import { LotNumberFilter } from '../modules/parcel/filters/lot-number.filter';
import { ParcelFormTableBlockRequiredValidator } from '../modules/product-group/validators';
import { ParcelFilterNeedAttentionPlugin } from '../modules/parcel/plugins/parcel-filter-need-attention.plugin';
import { ParcelYieldOnlyPlugin } from '../modules/parcel/plugins/parcel-yield-only-crop.plugin';
import { ParcelFilterStatusChangePlugin } from '../modules/parcel/plugins/parcel-filter-status-change.plugin';
import { FertilizationPlanDateValidator } from '../modules/offer/validators';
import SubscriptionYearlyPriceField from '../modules/subscription/components/SubscriptionYearlyPriceField.vue';
import ProplantaHarvestYearTitle from '../modules/proplanta/components/proplanta-harvest-year-title/ProplantaHarvestYearTitle.vue';
import TraditionalSwitch from '../modules/parcel/components/TraditionalSwitch.vue';
import TraditionalInfo from '../modules/parcel/components/TraditionalInfo.vue';

export const registerValidators = () => {
  formService.registerValidator('plantingDate', PlantingDateValidator);
  formService.registerValidator('harvestDate', HarvestDateValidator);
  formService.registerValidator('yieldAmount', YieldAmountValidator);
  formService.registerValidator('parcelFormTableBlockRequired', ParcelFormTableBlockRequiredValidator);
  formService.registerValidator('ekNumbers', EkNumbersValidator);
  formService.registerValidator('parcelArea', ParcelAreaValidator);
  formService.registerValidator('fertilizationPlanDate', FertilizationPlanDateValidator);
};

export const registerFilters = () => {
  formService.registerFilter('lotNumber', LotNumberFilter);
};

export const registerPlugins = () => {
  formService.registerPlugin('parcelFilterNeedAttention', ParcelFilterNeedAttentionPlugin);
  formService.registerPlugin('parcelFilterStatusChange', ParcelFilterStatusChangePlugin);
  formService.registerPlugin('parcelYieldOnlyCrop', ParcelYieldOnlyPlugin);
};

export const registerElements = () => {
  formService.registerFormElement('subscriptionYearlyPriceField', {
    class: FormElement,
    componentClass: SubscriptionYearlyPriceField
  });
  formService.registerFormElement('traditionalSwitch', {
    class: FormElement,
    componentClass: TraditionalSwitch
  });
  formService.registerFormElement('traditionalInfo', {
    class: FormElement,
    componentClass: TraditionalInfo
  });
  formService.registerFormElement('proplantaHarvestYearTitle', {
    class: FormElement,
    componentClass: ProplantaHarvestYearTitle
  });
};

export const initForms = () => {
  registerValidators();
  registerFilters();
  registerPlugins();
  registerElements();
};
